import { isNil } from 'lodash';

import { ILocalizationService } from '@step/vue/src/layouts/types';

export interface IDxDefaultSettngsOptions {
	localizationService: ILocalizationService;
	captionsJoinString?: string | null;
}

export interface IDxUiComponentItem {
	captionCode: string | string[];
	captionsJoinString?: string | null;
	searchCaption?: string | null;
}
export type DxMultipleComponentItemType = Partial<Record<DxComponents, IDxUiComponentItem>> & { searchCaption?: string | null };
type DxComponents =
	'dxDropDownBox' |
	'dxList' |
	'dxSelectBox' |
	'dxTreeView';

export function isIDxUiComponentItem(item: any): item is IDxUiComponentItem {
	const test = item as DxMultipleComponentItemType;
	return isNil(test.dxDropDownBox)
					&& isNil(test.dxList)
					&& isNil(test.dxSelectBox)
					&& isNil(test.dxTreeView);
}

export function isDxMultipleComponentItemType(item: any): item is DxMultipleComponentItemType {
	return !isIDxUiComponentItem(item);
}

export function isDxMultipleComponentItemWithDropDownBox(item: any): item is Record<'dxDropDownBox', IDxUiComponentItem>  {
	return isDxMultipleComponentItemType(item) && !isNil(item.dxTreeView);
}
export function isDxMultipleComponentItemWithList(item: any): item is Record<'dxList', IDxUiComponentItem>  {
	return isDxMultipleComponentItemType(item) && !isNil(item.dxSelectBox);
}
export function isDxMultipleComponentItemWithSelectBox(item: any): item is Record<'dxSelectBox', IDxUiComponentItem>  {
	return isDxMultipleComponentItemType(item) && !isNil(item.dxSelectBox);
}
export function isDxMultipleComponentItemWithTreeView(item: any): item is Record<'dxTreeView', IDxUiComponentItem>  {
	return isDxMultipleComponentItemType(item) && !isNil(item.dxTreeView);
}
